import { type Region, getRegion } from './RegionUtil';
import DeviceEnvUtil from './DeviceEnvUtil';

export interface StoreEntry {
  ios: string;
  android: string;
  harmony: string;
  harmonyEnterprise: string;
}

export const STORE_URLS: Record<Region, StoreEntry> = {
  cn: {
    ios: 'https://apps.apple.com/cn/app/apple-store/id599852710?pt=391097&ct=weboffice_output&mt=8',
    android: '',
    harmony: 'store://appgallery.huawei.com/app/detail?id=cn.wps.mobileoffice.hap',
    harmonyEnterprise: 'store://appgallery.huawei.com/app/detail?id=cn.wps.mobileoffice.hap.ent',
  },
  global: {
    ios: 'https://apps.apple.com/us/app/apple-store/id1491101673',
    android: 'https://play.google.com/store/apps/details?id=cn.wps.moffice_eng',
    harmony: 'store://appgallery.huawei.com/app/detail?id=cn.wps.mobileoffice.hap',
    harmonyEnterprise: 'store://appgallery.huawei.com/app/detail?id=cn.wps.mobileoffice.hap.ent',
  },
};

export const ENTERPRISE_HOSTNAME = 'abilityplus.wps.cn';
const ANDROID_PLAY_FALLBACK_DELAY_MS = 1000;

// ============================================================
// 商店链接
// ============================================================

export function getIOSStoreUrl(): string {
  return STORE_URLS[getRegion()].ios;
}

export function getHarmonyStoreUrl(): string {
  const region = getRegion();
  if (region === 'cn' && window.location.hostname === ENTERPRISE_HOSTNAME) {
    return STORE_URLS.cn.harmonyEnterprise;
  }
  return STORE_URLS[region].harmony;
}

export function getAndroidStoreUrl(): string {
  return STORE_URLS[getRegion()].android;
}

export function getStoreUrlByPlatform(): string {
  if (DeviceEnvUtil.isIOS()) {
    return getIOSStoreUrl();
  }
  if (DeviceEnvUtil.isHarmony()) {
    return getHarmonyStoreUrl();
  }
  return getAndroidStoreUrl();
}

export function openStoreByPlatform(finalFallbackUrl = ''): void {
  if (DeviceEnvUtil.isIOS()) {
    window.location.href = getIOSStoreUrl();
    return;
  }
  if (DeviceEnvUtil.isHarmony()) {
    window.location.href = getHarmonyStoreUrl();
    return;
  }
  openAndroidStoreWithFallback(finalFallbackUrl);
}

function openAndroidStoreWithFallback(finalFallbackUrl: string): void {
  const region = getRegion();
  const googlePlayWebUrl = getAndroidStoreUrl();
  const fallback = finalFallbackUrl;

  // 国内逻辑保持不变：直接使用配置链接，缺省则走业务下载兜底。
  if (region === 'cn') {
    const cnTarget = googlePlayWebUrl || fallback;
    if (cnTarget) {
      window.location.href = cnTarget;
    }
    return;
  }

  const marketUri = `market://details?id=cn.wps.moffice_eng`;
  const webUrl = googlePlayWebUrl || fallback;

  if (!marketUri && !webUrl) {
    return;
  }

  if (marketUri) {
    window.location.href = marketUri;
  } else if (webUrl) {
    window.location.href = webUrl;
  }

  if (!webUrl) {
    return;
  }

  setTimeout(() => {
    if (isPageHidden()) {
      return;
    }
    window.location.href = webUrl;
  }, ANDROID_PLAY_FALLBACK_DELAY_MS);
}

function isPageHidden(): boolean {
  const doc = document as Document & { webkitHidden?: boolean };
  return Boolean(doc.hidden || doc.webkitHidden);
}
